<template>
  <el-scrollbar v-if="rows">
    <el-menu @select="handleSelect" :default-active="$route.name" :collapse="isCollapse" :collapse-transition="false" :background-color="backgroundcolor" :text-color="textcolor" :active-text-color="activetextcolor">
      <nodes v-for="item in rows" :key="item.name" :row="item" :basePath="basePath" />
    </el-menu>
  </el-scrollbar>
</template>

<script>
export default {
  name: 'sidebar',
  components: {
    nodes: () => import("./node")
  },
  props: {
    rows: { type: Array, required: true },
    basePath: { type: String, default: '' },
    isCollapse: { type: Boolean, default: false },
    backgroundcolor: { type: String, default: null },
    textcolor: { type: String, default: null },
    activetextcolor: { type: String, default: null },
  },
  methods: {
    handleSelect (index) {
      if (/^https:\/\/|http:\/\//.test(index)) {
        this.$utils.common.open(index)
      }
      else {
        this.$router.push({
          name: index,
          params: this.$route.params
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
:deep(.el-menu) {
  border: none;
  .el-submenu {
    i:first-child {
      margin-right: 10px;
    }
    .el-submenu {
      .el-submenu__title {
        padding: 0 20px 0 54px !important;
        opacity: 0.6;
      }
      i:first-child {
        display: none;
      }
    }
    .el-menu-item {
      padding: 0 20px 0 54px !important;
      i:first-child {
        display: none;
      }
    }

    .el-submenu__title:hover,
    .el-menu-item:hover {
      background-color: rgba($color: #000000, $alpha: 0.2);
    }
  }
}
:deep(.el-menu--collapse) {
  .el-submenu {
    &__title {
      :not(:first-child) {
        display: none;
      }
    }
  }
}
</style>